import {RestrictedRouteModuleConfiguration} from "../router/model/UserPermission";
import {
    AddressModuleName,
    BranchModuleName,
    BranchServiceModuleName,
    BrandServiceModuleName,
    DragularModuleName,
    InstanceConfigurationModuleName,
    MD_COLOR_PICKER_MODULE_NAME,
    NgMessagesModule,
    ThemeColourPickerModuleName,
    UserServiceModuleName
} from "../utils/names/optionalModuleNames";
import {AngularJsMaterialModuleName} from "../utils/names/requiredModulesNames";
import {BranchControllerName} from "../utils/names/controllerNames";
import {NavigationAccessRoles, NavigationItem} from "../main/model/navigationItem";
import {UserGranredAuthorityName} from "../router/const/AllPermitions";
import {getTabName} from "modules/utils/TabNameUtils";

export const BranchModuleConfig = new RestrictedRouteModuleConfiguration(
    BranchModuleName,
    [
        BranchModuleName,
        BranchServiceModuleName,
        DragularModuleName,
        BrandServiceModuleName,
        UserServiceModuleName,
        AngularJsMaterialModuleName,
        ThemeColourPickerModuleName,
        AddressModuleName,
        NgMessagesModule,
        MD_COLOR_PICKER_MODULE_NAME,
        InstanceConfigurationModuleName
    ],
    [
        ['/branch', {
            // language=file-reference
            template: require('./route/BranchRoute.html'),
            controller: BranchControllerName,
        }]
    ],
    [new NavigationItem({
        title: 'Branches',
        href: '#!branch',
        accessRole: [NavigationAccessRoles.ROLE_ADMIN],
        activeFunction: (name) => name.indexOf("branch") != -1
    })],
    [
        BranchModuleName
    ],
    [UserGranredAuthorityName.BRANCH],
     getTabName() + '| Branches'
);

export default BranchModuleConfig;